import React from 'react';
import { IndexRoute, Route } from 'react-router';
import ActionsDrafts from './actionsDrafts';

export default (
  <Route path="rascunhos">
    <IndexRoute component={props => <ActionsDrafts {...props} />} />
  </Route>
);
